import { Box, Collapse, Stack } from "@mui/material"
import { AreaUnits, LengthUnits } from "convert-units"
import { NumberCalculationField } from "../../components/Fields/NumberCalculation"
import { Label } from "../../components/Typography/Typography"
import { isAoiTypeCorridor } from "../../models/aois/AoiName"
import { convertArea, convertLength } from "../../utils/UnitCalculations"
import { useProjectEditStore } from "../../zstore/ProjectEditStore"

// Database saves area contracted in square meters
const areaContractedDefaultUnit: AreaUnits = "m2"
const areaContractedConvertUnits: AreaUnits[] = ["mi2", "ac", "km2"]

// DB saves corridor miles in meters
const corridorMilesDefaultUnit: LengthUnits = "m"
const corridorMilesConvertUnits: LengthUnits[] = ["nMi", "mi", "km"]

export const AOICalculations = () => {
    const selectedAoi = useProjectEditStore((state) => state.selectedAoi)
    const updateSelectedAoi = useProjectEditStore((state) => state.updateAoiField)

    if (selectedAoi == null) {
        return null
    }

    const isCorridor = isAoiTypeCorridor(selectedAoi.aoi_type)

    return (
        <Stack>
            <Box sx={{ pb: 2 }}>
                <Label gutterBottom="sm">Contracted Area</Label>
                <NumberCalculationField
                    disabled={isCorridor}
                    convertFunc={convertArea}
                    value={selectedAoi.area_contracted_m2}
                    defaultType={areaContractedDefaultUnit}
                    convertUnits={areaContractedConvertUnits}
                    onChange={async (value) => {
                        await updateSelectedAoi("area_contracted_m2", value ?? undefined)
                    }}
                />
            </Box>
            <Collapse in={isCorridor}>
                <Label gutterBottom="sm">Corridor Miles</Label>
                <NumberCalculationField
                    convertFunc={convertLength}
                    value={selectedAoi.corridor_length_m}
                    defaultType={corridorMilesDefaultUnit}
                    convertUnits={corridorMilesConvertUnits}
                    onChange={async (value) => await updateSelectedAoi("corridor_length_m", value ?? undefined)}
                />
            </Collapse>
        </Stack>
    )
}
